/* STC_HOME_ANIM_V1 */
(function(){
  try{
    // Dawn normalmente pone "template-index" en body
    if(!document.body || !document.body.classList.contains('template-index')) return;

    // Respeta reduced motion
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Selecciona SOLO secciones del contenido principal
    var main = document.querySelector('main');
    if(!main) return;

    var sections = Array.prototype.slice.call(main.querySelectorAll('.shopify-section'));
    if(!sections.length) return;

    // Evita re-aplicar
    sections = sections.filter(function(sec){
      return !sec.classList.contains('stc-ha') && !sec.hasAttribute('data-stc-no-anim');
    });

    // Marca visible inmediato si ya está en viewport (evita “flash”)
    var vh = window.innerHeight || 800;
    sections.forEach(function(sec){
      var r = sec.getBoundingClientRect();
      sec.classList.add('stc-ha');
      if(r.top < vh * 0.92) sec.classList.add('stc-ha--in');
    });

    // Observer: activa al entrar
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('stc-ha--in');
          io.unobserve(entry.target); // una sola vez => rendimiento top
        }
      });
    }, {
      root: null,
      threshold: 0.08,
      rootMargin: '0px 0px -10% 0px'
    });

    sections.forEach(function(sec){ io.observe(sec); });

  }catch(e){
    // Silencioso: jamás rompe la página
  }
})();
